// extracted by mini-css-extract-plugin
export default {"root":"IconUpcoming_root__ZcZfU"};